import { render, staticRenderFns } from "./RemittanceScheduleConfig.vue?vue&type=template&id=04dcbbe3"
import script from "./RemittanceScheduleConfig.vue?vue&type=script&lang=ts"
export * from "./RemittanceScheduleConfig.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports